const cmsModule = name => require(`@components/${name}/${name}.cms`).default;
const cmsTemplate = name => require(`@templates/${name}/${name}.cms`).default;
const cmsPreviewPane = () => {
	return (this || global || globalThis).window && document.querySelector('[class*=PreviewPaneFrame]');
};

export { cmsModule, cmsTemplate, cmsPreviewPane };
